module.exports = __webpack_public_path__ + "img/toggle.df3baf58.svg";